import { useForm } from "react-hook-form";
import { Button, Input } from "../ui";
import { RxReload } from "react-icons/rx";
import useBasicLogin from "../../hooks/auth/useBasicLogin";
import { useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

const UsernamePassword = () => {
  const { control, handleSubmit } = useForm({
    defaultValues: {
      email: "",
      password: "",
    },
  });
  const { handleLoginUser, loginUser } = useBasicLogin();
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="w-[69.5%] space-y-4">
      <Input
        control={control}
        label={"Email"}
        name={"email"}
        placeholder={"Please Enter Email"}
        rules={{
          required: "Email is required",
        }}
      />
      <div className="relative">
        <Input
          control={control}
          label={"Password"}
          type={showPassword ? "text" : "password"}
          name={"password"}
          placeholder={"Please Enter Password"}
          rules={{
            required: "Password is required",
          }}
        />
        <Button
          type="button"
          variant={"ghost"}
          className={"absolute right-3 top-[50%] transform  text-gray-500"}
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? (
            <AiOutlineEyeInvisible className="w-5  h-5" />
          ) : (
            <AiOutlineEye className="w-5 h-5" />
          )}
        </Button>
      </div>
      <Button
        onClick={handleSubmit(handleLoginUser)}
        disabled={loginUser.isLoading}
      >
        <span className="mr-1.5">Login</span>
        {loginUser.isLoading && <RxReload className=" animate-spin" />}
      </Button>
    </div>
  );
};

export default UsernamePassword;
